// extracted by mini-css-extract-plugin
export var avatarContainer = "_5g-0";
export var avatarTypingWave = "_5g-i";
export var gray = "_5g-f";
export var green = "_5g-c";
export var icon = "_5g-9";
export var image = "_5g-1";
export var lg = "_5g-6";
export var md = "_5g-5";
export var presenceDot = "_5g-b";
export var red = "_5g-d";
export var sm = "_5g-4";
export var status = "_5g-a";
export var typingDot = "_5g-h";
export var typingPill = "_5g-g";
export var xl = "_5g-7";
export var xs = "_5g-3";
export var xxl = "_5g-8";
export var xxs = "_5g-2";
export var yellow = "_5g-e";